/**
 * Created by Shikha on 2021-09-14.
 */

import {Oktoberfest} from "../Oktoberfest";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {TweenLite,Linear,TimelineLite} from "gsap";
import {GameHelper} from "../../core/utils/GameHelper";
import {Helper} from "@nolimitcity/slot-launcher/bin/utils/Helper";
import {OktoberfestGameMode} from "../server/OktoberfestGameMode";
import {OktoberfestParsedInitData} from "../server/data/OktoberfestParsedInitData";
import {OktoberfestParsedGameData} from "../server/data/OktoberfestParsedGameData";

export class GameForeground extends PIXI.Container {

    private _foreGroundFrillsUp: TimelineSprite;
    private _foreGroundBottom: PIXI.Sprite;
    private _foreGroundBottom2: PIXI.Sprite;//#700
    private _foreGroundTopPortrait: PIXI.Sprite;
    private _foreGroundBottomPortrait: PIXI.Sprite;
    private _flagAnimation:TimelineLite;
    private _logo: TimelineSprite;
    private _freespinIntroForeGroundTween: TimelineLite;

    constructor() {
        super();
        this.init();
        this.onResize();
        this.onOrientationChanged();
    }

    public onResize(): void {
        if (!(NolimitApplication.isLandscape)){
            this._foreGroundBottomPortrait.visible = true;
            this._foreGroundBottom.visible = false;
            this._foreGroundBottom2.visible = false;
            this._logo.y = 90;
            this._logo.scale.set(1.5);
            this._foreGroundTopPortrait.y =67;
            this._foreGroundFrillsUp.y =105;

            if(!Helper.isDefaultScreenRatio(NolimitApplication.screenBounds)){
                if(!(NolimitApplication.isLandscape)){
                    this._foreGroundBottomPortrait.visible = true;
                    this._foreGroundBottom.visible = false;
                    this._logo.scale.set(1.2);
                    this._foreGroundBottom2.visible = false;
                }
            }
        }else{
            this._foreGroundBottom.visible = true;
            this._foreGroundBottom2.visible = true;
            this._foreGroundTopPortrait.visible = true;
            this._foreGroundBottomPortrait.visible = false;
            this._foreGroundTopPortrait.position.y=0;
            this._logo.y = 60;
            this._logo.scale.set(0.97);
            this._foreGroundFrillsUp.y =46;

            const parsedData: OktoberfestParsedInitData | OktoberfestParsedGameData = Oktoberfest.model.parsedGameData ? Oktoberfest.model.parsedGameData : Oktoberfest.model.parsedInitData;
            if(parsedData.mode === OktoberfestGameMode.FREESPIN) {
                this.showLogoStatic();
            }
        }
    }

    public onOrientationChanged(): void {
        if (Oktoberfest.model.isRestore && Oktoberfest.model.initData.mode === GameMode.FREESPIN && !NolimitApplication.isLandscape) {
            //portrait fsMode
            this._foreGroundFrillsUp.visible = true;
            this._foreGroundTopPortrait.alpha = 1;
            this._logo.visible = true;
        }
    }

    public onFreespinIntroPanning(duration: number): void {
        this._foreGroundBottom.x =390;
        if(GameHelper.isDesktop()) {
            this._logo.x = 230;
            this._foreGroundFrillsUp.x = 230;
            this._foreGroundBottom.x=390;
        }
    }

    public onFreespinIntroPanningComplete(): void {
        this._foreGroundFrillsUp.alpha = 1;
        this._foreGroundTopPortrait.alpha = 1;
        if (this._freespinIntroForeGroundTween && this._freespinIntroForeGroundTween.isActive()) {
            this._freespinIntroForeGroundTween.kill();
        }

    }

    public playLogoFSAnimation(): void {
        const parsedData: OktoberfestParsedInitData | OktoberfestParsedGameData = Oktoberfest.model.parsedGameData ? Oktoberfest.model.parsedGameData : Oktoberfest.model.parsedInitData;
        if(parsedData.freespinTriggeredThisSpin){
            this._logo.show();
            this._logo.getAnimationAutoShowHide(true, false);
        }
    }

    public resetLogoDefaultState(): void {
        this._logo.setFrame(0);
        this.showLogoStatic();
        this._foreGroundBottom.x =550;
        if(!GameHelper.isDesktop()){
            this._foreGroundBottom.x=390;
        }
        this._logo.x =360;
        this._foreGroundFrillsUp.x =360;
        if(NolimitApplication.isLandscape && Oktoberfest.model.parsedGameData.mode===GameMode.FREESPIN && Oktoberfest.model.parsedGameData.nextMode ===  GameMode.FREESPIN){
            this._logo.x =230;
            this._foreGroundFrillsUp.x =230;
            this._foreGroundBottom.x=390;
        }
    }

    public hideLogo(): void {
        if (!NolimitApplication.isLandscape) {
            this._logo.visible = false;
        }
    }
    public logoPanning(): void {
        if(GameHelper.isDesktop()){
            this._freespinIntroForeGroundTween = new TimelineLite();
            this._freespinIntroForeGroundTween.add(()=>{
                new TweenLite(this._foreGroundBottom,{x:390,duration: OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_DURATION,
                    ease: OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_EASE}),
                    new TweenLite(this._logo,{x:230,duration: OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_DURATION,
                        ease: OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_EASE})
                new TweenLite(this._foreGroundFrillsUp,{x:230,duration: OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_DURATION,
                    ease: OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_EASE})
            });
        }
    }

    public desktopDefaultForegroundSetting():void{
        this._foreGroundBottom.x=550;
        this._logo.x=360;
        this._foreGroundFrillsUp.x=360;
    }

    public setLogoGoldenFrame(): void {
        this._logo.setFrame(21);
    }

    public showLogoStaticInFS():void{
        if (GameHelper.isDesktop()) {
            this._foreGroundBottom.x = 390;
            this._logo.x =230;
            this._foreGroundFrillsUp.x=230;
        }
    }
    public showLogoStatic(): void {
        const parsedData: OktoberfestParsedInitData | OktoberfestParsedGameData = Oktoberfest.model.parsedGameData ? Oktoberfest.model.parsedGameData : Oktoberfest.model.parsedInitData;

        if(parsedData.nextMode ===  GameMode.FREESPIN){
            this.showLogoStaticInFS();
        }else {
            this._logo.setFrame(0);
            this._foreGroundBottom.x =550;
        }
    }

    public playFrillAnimationUp(): void {
        if (NolimitApplication.isLandscape) {
            this._foreGroundFrillsUp.show();
            this._flagAnimation.play(0);
        }else{
            this._foreGroundFrillsUp.show();
        }
    }

    public playFrillAnimationDown(): void {
        if (NolimitApplication.isLandscape) {
            this._flagAnimation.reverse(0);
        }else{
            this._foreGroundFrillsUp.show();
        }
    }

    private init(): void {
        this.createLogoGraphics();
        this.createLandscapeGraphics();
        this.createPortraitGraphics();
        OktoberfestLayers.getLayer(Layers.LOGO)!.addChild(this._logo);
        OktoberfestLayers.getLayer(Layers.FOREGROUND)!.addChild(this);
        this.createFrills();
    }

    private createFrills(): void {
        this._foreGroundFrillsUp = new TimelineSprite(Oktoberfest.assetLoader.getTextures("flagsUp"));
        this._foreGroundFrillsUp.position.set(360, 46);
        this._foreGroundFrillsUp.anchor.set(0.5, 0.5);
        this._foreGroundFrillsUp.name = "frillsUp";
        this._flagAnimation =this._foreGroundFrillsUp.getAnimation([0]);
        this._flagAnimation.pause(0);
        this.addChild(this._foreGroundFrillsUp);
    }

    private createLandscapeGraphics(): void {
        this._foreGroundBottom = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("foreground")[0]);
        this._foreGroundBottom2 = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("foreground_mobile_landscape_top")[0]);
        this._foreGroundBottom.anchor.set(0.5, 0.5);
        this._foreGroundBottom.scale.set(1, 1);
        this._foreGroundBottom.position.set(550, 657);
        if(!GameHelper.isDesktop()){
            this._foreGroundBottom.position.set(390, 657);
        }
        this._foreGroundBottom2.anchor.set(0.5, 0.5);
        this._foreGroundBottom2.scale.set(1, 1);
        this._foreGroundBottom2.position.set(-400, 688);
        this._foreGroundBottom2.rotation=355;
        this.addChild(this._foreGroundBottom2,this._foreGroundBottom);
    }

    private createLogoGraphics(): void {
        this._logo = new TimelineSprite(Oktoberfest.assetLoader.getTextures("logo-fs"));
        this._logo.scale.set(0.97);
        this._logo.position.set(360, 50);
        this._logo.anchor.set(0.5, 0.5);
        this._logo.name = "fs-logo";
    }

    private createPortraitGraphics(): void {
        this._foreGroundTopPortrait = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("foreground_mobile_landscape_top")[0]);
        this._foreGroundTopPortrait.anchor.set(0.5, 0.5);
        this._foreGroundTopPortrait.position.set(360, 0);

        this._foreGroundBottomPortrait = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("foreground_portrait")[0]);
        this._foreGroundBottomPortrait.anchor.set(0.5, 0.5);
        this._foreGroundBottomPortrait.position.set(359, 862);

        this.addChild(this._foreGroundTopPortrait, this._foreGroundBottomPortrait);
    }
}